import React, { Component } from "react";

import { Translate } from "react-redux-i18n";

import { roundToDecimals, momentModule } from "../../utils/Utils";

import "../../../styles/components/insights/insights/MyInsights.scss";
import station from "../../../styles/images/station_grey.svg";
import stopwatch from "../../../styles/images/stopwatch.svg";
import big_battery from "../../../styles/images/big_battery.svg";
import money from "../../../styles/images/money.svg";
import energy from "../../../styles/images/energy.svg";
import co2 from "../../../styles/images/co2_big.svg";

import "../../../styles/utils/_loadingScreen.scss";

const { moment } = momentModule;

class MyChargers extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div
        id="myChargers"
        className={"highlight-container " + (this.props.hoverable ? "hoverable" : "")}
        onClick={this.props.hoverable ? this.props.onClick : null}
      >
        {!this.props.loading ? (
          <>
            <div className="highlight-container-header">
              <img src={station} alt="" />
              <Translate value="insights_myChargers" />
              <p className="counter">{this.props.counter || 0}</p>
            </div>
            <div className="highlight-container-body" onWheel={e => e.currentTarget.scroll(e.deltaY, 0)}>
              <div className="kpi">
                <div className="kpi-icon">
                  <img src={stopwatch} alt="" />
                </div>
                <div className="kpi-label">
                  <p className="kpi-text">
                    {(this.props.myChargers &&
                      moment
                        .duration(this.props.myChargers.totalChargingTime, "hours")
                        .format("h[h] m[m]")) ||
                      "0h"}
                  </p>
                  <Translate value="insights_totalChargingTime" />
                </div>
              </div>
              <div className="kpi">
                <div className="kpi-icon">
                  <img src={big_battery} alt="" />
                </div>
                <div className="kpi-label">
                  <p className="kpi-text">
                    {(this.props.myChargers && this.props.myChargers.totalSessions) || 0}
                  </p>
                  <Translate value="insights_totalSessions" />
                </div>
              </div>
              <div className="kpi">
                <div className="kpi-icon">
                  <img src={money} alt="" />
                </div>
                <div className="kpi-label">
                  <p className="kpi-text">{(this.props.myChargers &&
                      `${roundToDecimals(this.props.myChargers.purchaseTariffDetailsExclVat, 2)}€`) ||
                      "0€"}</p>
                  <Translate value="insightsByCar_totalSpent" />
                </div>
              </div>
              <div className="kpi">
                <div className="kpi-icon">
                  <img src={money} alt="" />
                </div>
                <div className="kpi-label">
                  <p className="kpi-text">
                    {(this.props.myChargers &&
                      `${roundToDecimals(this.props.myChargers.incomeExclVat, 2)}€`) ||
                      "0€"}
                  </p>
                  <Translate value="insights_totalIncome" />
                </div>
              </div>
              <div className="kpi">
                <div className="kpi-icon">
                  <img src={energy} alt="" />
                </div>
                <div className="kpi-label">
                  <p className="kpi-text">
                    {(this.props.myChargers &&
                      `${roundToDecimals(
                        this.props.myChargers.totalEnergy,
                        this.props.myChargers.totalEnergy > 9 ? 1 : 3
                      )} kWh`) ||
                      "0kWh"}
                  </p>
                  <Translate value="insights_totalEnergy" />
                </div>
              </div>
              <div className="kpi">
                <div className="kpi-icon">
                  <img src={co2} alt="" />
                </div>
                <div className="kpi-label">
                  <p className="kpi-text">
                    {(this.props.myChargers &&
                      `${roundToDecimals(
                        this.props.myChargers.totalCO2Saved,
                        this.props.myChargers.totalCO2Saved > 9 ? 1 : 3
                      )} Kg`) ||
                      "0kg"}
                  </p>
                  <Translate value="detailsGroupChargingSessions_CO2Saved" />
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="loading-container">
            <div className="loading-spinner">
              <div className="generic-loading">
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default MyChargers;
